import { create } from 'zustand'
import api from '../api/axios'

export const useGamificationStore = create((set, get) => ({
  xp: 0,
  level: 1,
  
  // Set initial data when logging in
  setInitialData: (xp, level) => set({ xp, level }),

  addXP: async (amount) => {
    try {
      // Optimistic update
      set((state) => {
        const newXp = state.xp + amount
        const newLevel = Math.floor(Math.sqrt(newXp / 100)) + 1
        return { xp: newXp, level: newLevel }
      });

      // API call
      await api.post('/auth/xp', { amount });
    } catch (e) {
      console.error(e);
      // Ideally we would revert on failure
    }
  }
}))
